import { expectType, TypeOf } from "ts-expect";

expectType<TypeOf<string, string>>(true);
